import { render } from "./PracticalTableView.vue?vue&type=template&id=3fdc659e&scoped=true"
import script from "./PracticalTableView.vue?vue&type=script&lang=js"
export * from "./PracticalTableView.vue?vue&type=script&lang=js"

import "./PracticalTableView.vue?vue&type=style&index=0&id=3fdc659e&scoped=true&lang=css"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdc659e"]])

export default __exports__